import type { ReactNode } from 'react';

interface PageHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  /** Primary action last; at most one `btn-primary` (DESIGN_SYSTEM.md §10). */
  actions?: ReactNode;
  /** Optional breadcrumb / back link rendered above the title. */
  eyebrow?: ReactNode;
  className?: string;
}

/** Standard page header (DESIGN_SYSTEM.md §3–4): title, one-line description, actions at the end. */
export default function PageHeader({ title, description, actions, eyebrow, className = '' }: PageHeaderProps) {
  return (
    <div className={`flex items-start justify-between gap-4 mb-6 flex-wrap ${className}`}>
      <div className="min-w-0">
        {eyebrow && <div className="mb-1.5">{eyebrow}</div>}
        <h1 className="text-2xl font-semibold tracking-tight text-surface-900">{title}</h1>
        {description && (
          <p className="text-sm text-surface-600 mt-1 max-w-2xl">{description}</p>
        )}
      </div>
      {actions && (
        <div className="flex items-center gap-2 flex-shrink-0 flex-wrap">
          {actions}
        </div>
      )}
    </div>
  );
}
